import { Link } from 'react-router-dom';

const WHATSAPP_NUM = '971547172715';

export default function CTASection() {
  return (
    <section className="relative py-32 px-6 lg:px-12 overflow-hidden bg-black">
      {/* Cinematic background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/48d083fdc5438046345063208febcd30.jpg"
          alt="خلفية العرض"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/98 via-black/80 to-black/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-black/60" />
      </div>

      {/* Cinematic letterbox */}
      <div className="absolute top-0 left-0 right-0 h-12 bg-black" />
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-black" />

      {/* Vertical accent */}
      <div className="absolute right-1/2 top-12 bottom-12 w-px bg-gradient-to-b from-transparent via-[#E8721A]/20 to-transparent hidden lg:block" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" dir="rtl">
        {/* Label */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="w-16 h-px bg-gradient-to-l from-[#E8721A] to-transparent" />
          <span className="text-[#E8721A] text-xs font-bold tracking-[0.3em] uppercase">ابدأ الآن</span>
          <div className="w-16 h-px bg-gradient-to-r from-[#E8721A] to-transparent" />
        </div>

        <h2 className="text-4xl lg:text-6xl font-black text-white mb-4 leading-tight" style={{ textShadow: '0 0 80px rgba(232,114,26,0.2)' }}>
          تواصل معنا
          <br />
          <span className="text-[#E8721A]">وابدأ شراكتك</span>
        </h2>
        <p className="text-white/40 text-sm mb-12 max-w-xl mx-auto leading-relaxed tracking-wide">
          فريقنا مستعد لمساعدتك في اختيار أفضل المنتجات المناسبة لمشروعك. تواصل معنا عبر واتساب وسنرد في الحال.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href={`https://wa.me/${WHATSAPP_NUM}`}
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 text-xs font-bold hover:bg-[#1da851] transition-all duration-300 cursor-pointer whitespace-nowrap tracking-widest uppercase"
            style={{ clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))' }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl" />
            </div>
            <span dir="ltr">+{WHATSAPP_NUM}</span>
          </a>
          <Link
            to="/products"
            className="flex items-center gap-2 border border-[#E8721A]/60 text-[#E8721A] px-8 py-4 text-xs font-bold hover:bg-[#E8721A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap tracking-widest uppercase"
          >
            <span>تصفح المنتجات</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
